import React from 'react'
import { FlightSearchWidgetState, initialState } from './flightSearchWidgetStateReducer'

const FlightSearchWidgetStateContext = React.createContext<FlightSearchWidgetState>(initialState)

export default FlightSearchWidgetStateContext
